import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '../omnidashboard.config';

@Injectable({ providedIn: 'root' })
export class OmnidashboardStorageService {
  hasLoginData(): boolean {
    return !!this.getItem(this.getLocalStorage(), STORAGE_KEYS.loginData);
  }

  isLogoutRequested(): boolean {
    return this.getItem(this.getLocalStorage(), STORAGE_KEYS.logOutFlag) === 'true';
  }

  getLoginDataRaw(): string | null {
    return this.getItem(this.getLocalStorage(), STORAGE_KEYS.loginData);
  }

  getAdminRoleId(): string | null {
    return this.getItem(this.getLocalStorage(), STORAGE_KEYS.adminId);
  }

  getSelectedFiscalYear(): string | null {
    return this.getItem(this.getSessionStorage(), STORAGE_KEYS.omniFiscalYear);
  }

  setSelectedFiscalYear(fiscalYear: string): void {
    this.setItem(this.getSessionStorage(), STORAGE_KEYS.omniFiscalYear, fiscalYear);
  }

  setSelectedChapterId(chapterId: string): void {
    this.setItem(this.getLocalStorage(), STORAGE_KEYS.chapterId, chapterId);
  }

  private getLocalStorage(): Storage | null {
    try {
      return typeof window !== 'undefined' ? window.localStorage : null;
    } catch {
      return null;
    }
  }

  private getSessionStorage(): Storage | null {
    try {
      return typeof window !== 'undefined' ? window.sessionStorage : null;
    } catch {
      return null;
    }
  }

  private getItem(storage: Storage | null, key: string): string | null {
    if (!storage) {
      return null;
    }
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  }

  private setItem(storage: Storage | null, key: string, value: string): void {
    if (!storage) {
      return;
    }
    try {
      storage.setItem(key, value);
    } catch {
      // Ignore quota/private-mode failures; reads already return null safely.
    }
  }
}
